define('gofer_parts_collection.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('gofer_parts_collection', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div><div class=\"\"><div data-type=\"backbone.collection.view.rows\"></div></div></div>";
},"useData":true}, 'extensions/Gofer Parts/GoferParts/1.0.0/', 'extensions/Gofer Parts/GoferParts/1.0.0/', Handlebars);
});